export default function Notification(message,variant,action = null){

    return {
        message: message,
        options:{
            key: new Date().getTime() + Math.random(),
            variant: variant,
            action: action ? action : null
        }
    }
    
}